import {
  getCurrencyLabel,
  isEnterKey,
  RadioButton,
  useConfig,
} from '@travelwin/core';

import { useCurrency } from '../../../context/Currency';
import { useLocaleUtils } from '../../../hooks/useLocaleUtils';
import { ClickEventData, useAnalytics } from '@/analytics';

const CurrencySwitch = ({
  onPanelClose,
  rootClassName,
  groupName = 'currency',
}: {
  onPanelClose: () => void;
  rootClassName: string;
  groupName?: string;
}) => {
  const { currentLocale } = useLocaleUtils();
  const { PAYMENT_SUPPORTED_CURRENCIES } = useConfig();
  const { currency, setCurrency } = useCurrency();
  const analyticsContext = useAnalytics();

  const handleItemClick = (currencyCode: string) => {
    setCurrency(currencyCode);

    const trackingData: ClickEventData = {
      element_id: 'btn_currency-switch',
      element_text: currencyCode,
    };

    analyticsContext.trackClickAction(trackingData);

    onPanelClose();
  };

  return (
    <div className={`${rootClassName}--panel`}>
      {PAYMENT_SUPPORTED_CURRENCIES?.map((currencyCode) => (
        <RadioButton
          key={currencyCode}
          value={currencyCode}
          label={getCurrencyLabel(currentLocale, currencyCode)}
          isChecked={currencyCode === currency}
          onClickLabel={() => handleItemClick(currencyCode)}
          onKeyDownLabel={(e) => isEnterKey(e) && handleItemClick(currencyCode)}
          onClick={() => handleItemClick(currencyCode)}
          group={groupName}
          data-testid={currencyCode}
        />
      ))}
    </div>
  );
};

export default CurrencySwitch;
